import { CircularProgress } from "@material-ui/core";
import useStyles from "./styles";
const Spinner = ({ blocking = false }) => {
  const classes = useStyles();
  return (
    <div className={blocking ? classes.blockingRoot : classes.root}>
      <CircularProgress />
    </div>
  );
};

export default Spinner;
